
  import { defineComponent, onMounted, ref } from 'vue';
  import { ErrorMessage, Field, Form } from 'vee-validate';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { useRouter, useRoute } from 'vue-router';
  import { Actions } from '@/store/enums/StoreEnums';
  import { FactorOptionObject } from '@/store/modules/IVE/FactorOptionsModule';
  import { useAbility } from '@casl/vue';
  import Factors from '@/store/enums/IVEOtherFactorsEnums';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import * as Yup from 'yup';

  export default defineComponent({
    name: 'back-street-editing',
    components: {
      ErrorMessage,
      Field,
      Form,
    },
    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const route = useRoute();
      const { can } = useAbility();
      const submitButton = ref<HTMLButtonElement | null>(null);

      onMounted(() => {
        setCurrentPageBreadcrumbs(translate('backStreetLengthOptionUpdating'), [
          translate('ive'),
        ]);
      });

      const { data } = await store.dispatch(
        Actions.GET_IVE_FACTOR_OPTION,
        route.params.id
      );

      const backStreetOption = ref<FactorOptionObject>(data.data);

      const translate = (text: string) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      const goBack = () => {
        router.back();
      };

      const validationSchema = Yup.object().shape({
        titleEn: Yup.string()
          .required(() => translate('EN_VALUE_IS_REQUIRED_FIELD'))
          .label('English Value'),
        titleAr: Yup.string()
          .required(() => translate('AR_VALUE_IS_REQUIRED_FIELD'))
          .label('Arabic Value'),
        multiplicationFactors: Yup.number()
          .required(() => translate('PERCENT_IS_REQUIRED_FIELD'))
          .label('Multiplication Factors'),
      });

      const onSubmitUpdate = async (values) => {
        values.factorId = Number(Factors.BACK_STREET_LENGTHS);
        if (submitButton.value) {
          // eslint-disable-next-line
          submitButton.value!.disabled = true;
          submitButton.value.setAttribute('data-kt-indicator', 'on');
        }

        await store.dispatch(Actions.UPDATE_IVE_FACTOR_OPTION, {
          id: backStreetOption.value?.id,
          data: values,
        });
        const [errorName] = Object.keys(store.getters.getErrors);
        const error = store.getters.getErrors[errorName];

        if (error) {
          Swal.fire({
            text: translate(error[0]),
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: translate('tryAgainExcl'),
            customClass: {
              confirmButton: 'btn fw-bold btn-light-danger',
            },
          });
          //Deactivate indicator
          submitButton.value?.removeAttribute('data-kt-indicator');
          // eslint-disable-next-line
          submitButton.value!.disabled = false;
        } else {
          Swal.fire({
            text: translate('SUCCESSFULLY_UPDATED_BACK_STREET_OPTION'),
            icon: 'success',
            buttonsStyling: false,
            confirmButtonText: translate('ok'),
            customClass: {
              confirmButton: 'btn btn-light-primary',
            },
          }).then(() => {
            router.push({ name: 'back-street-listing' });
          });
        }
      };

      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');

      return {
        onSubmitUpdate,
        submitButton,
        translate,
        validationSchema,
        goBack,
        backStreetOption,
        can,
      };
    },
  });
